import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';
import {
  FACTORING_HEADER_TITLE_CLASS_NAME,
  FACTORING_HEADER_DESCRIPTION_CLASS_NAME,
} from '../../theme/constants/typography';

const FactoringHeaderContent = ({
  headerTitle,
  headerDescription,
  headerDescriptionProps,
  isMobile,
  RightComponent,
  showRightComponentInMobile,
}) => (
  <>
    <Grid item xs={12} md={RightComponent ? 6 : 8}>
      <Box>
        <Typography
          variant={isMobile ? 'medium_1' : 'large_2'}
          fontWeight={700}
          className={FACTORING_HEADER_TITLE_CLASS_NAME}
        >
          {headerTitle}
        </Typography>
        <Typography
          variant={isMobile ? 'small_2' : 'small_3'}
          mt={0.5}
          color="gray.A500"
          component="span"
          display="block"
          className={FACTORING_HEADER_DESCRIPTION_CLASS_NAME}
          {...headerDescriptionProps}
        >
          {headerDescription}
        </Typography>
      </Box>
    </Grid>
    {(!isMobile || showRightComponentInMobile) && (
      <Grid item xs={12} md={RightComponent ? 6 : 4} mt={isMobile ? 2 : 0}>
        {RightComponent && (
          <Box display="flex" justifyContent="flex-end" width="100%">
            {RightComponent}
          </Box>
        )}
      </Grid>
    )}
  </>
);

FactoringHeaderContent.propTypes = {
  headerTitle: PropTypes.string.isRequired,
  headerDescription: PropTypes.string,
  headerDescriptionProps: PropTypes.shape({
    variant: PropTypes.string,
    fontWeight: PropTypes.number,
  }),
  isMobile: PropTypes.bool.isRequired,
  RightComponent: PropTypes.node,
  showRightComponentInMobile: PropTypes.bool,
};

FactoringHeaderContent.defaultProps = {
  headerDescription: '',
  headerDescriptionProps: null,
  RightComponent: null,
  showRightComponentInMobile: false,
};

export default FactoringHeaderContent;
